import {useEffect,useRef,useState} from "react";
import type {StoreCategoryScope} from "./storeCategoryMode";

type WeekdayRow={label:string;net_sales_uzs:number;net_units:number};
type Result<T>={key:string;rows?:T[];error?:string};
const empty:never[]=[];

// Read the existing Store Report's authoritative weekday rows. Moving their
// screen does not create another aggregation or change any workbook producer.
export function useExecutiveWeekdays<T extends WeekdayRow>(scope:StoreCategoryScope){
 const key=JSON.stringify([scope.releaseId,scope.params]);
 const [result,setResult]=useState<Result<T>>({key:""});
 const cache=useRef(new Map<string,T[]>());
 useEffect(()=>{
  const known=cache.current.get(key);if(known){setResult({key,rows:known});return;}
  const controller=new AbortController();let active=true;setResult({key});
  void(async()=>{try{
   const response=await fetch(`/api/v1/store/report?${scope.params}`,{signal:controller.signal});
   if(!response.ok)throw Error("Veri açılamadı.");
   const data=await response.json(),params=new URLSearchParams(scope.params);
   if(data.release_id!==scope.releaseId||data.period?.start!==params.get("start")||data.period?.end!==params.get("end"))throw Error("Veri sürümü değişti. Sayfayı yenileyin.");
   if(!Array.isArray(data.weekdays)||data.weekdays.some((r:WeekdayRow)=>typeof r.label!=="string"||!Number.isFinite(r.net_sales_uzs)||!Number.isFinite(r.net_units)))throw Error("Veri açılamadı.");
   if(!active)return;if(cache.current.size>=4)cache.current.delete(cache.current.keys().next().value!);
   cache.current.set(key,data.weekdays);setResult({key,rows:data.weekdays});
  }catch(error){if(active)setResult({key,error:error instanceof Error?error.message:"Veri açılamadı."});}})();
  return()=>{active=false;controller.abort();};
 },[key]);
 const current=result.key===key?result:undefined;
 return{rows:current?.rows??empty,error:current?.error,loading:!current?.rows&&!current?.error};
}
